<template>
  <div>
    <fg-input
      type="tel"
      label="Логин"
      labelKey="login"
      class="mb-3"
      v-mask="`+998#########`"
      v-model="phone"
      placeholder="+998"
    ></fg-input>
    <fg-input
      type="password"
      label="Пароль"
      labelKey="password"
      v-model="password"
      placeholder="Введите пароль"
    ></fg-input>
    <br />
    <button class="w-100 mb-3 btn btn-info" round @click="login">
      {{ "login" | setText("Войти в систему") }}
    </button>
  </div>
</template>

<script>
import { errorNotify } from "@/plugins/functions";

export default {
  name: "login",
  components: {},
  mounted() {},
  data() {
    return {
      phone: "+998",
      password: "",
    };
  },
  methods: {
    login(loading = true) {
      this.$loading(true);
      this.$http
        .post("auth/login?v=1", {
          phone: this.phone,
          password: this.password,
        })
        .then((response) => {
          let token = response.headers["x-access-token"];
          this.$http.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${token}`;
          localStorage.setItem("token", `Bearer ${token}`);
          this.$store.dispatch("setUser", response.data.data);
          this.$store.dispatch("setRoutes", response.data.data.sections);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
        });
    },
  },
};
</script>
<style>
</style>
